module.exports = __webpack_public_path__ + "static/media/Map.50ea0c4c.svg";